import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  color: "primary"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["item"]
const _hoisted_7 = {
  key: 0,
  color: "primary",
  class: "menuItem"
}
const _hoisted_8 = { class: "version-info" }
const _hoisted_9 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_my_notifications = _resolveComponent("my-notifications")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, {
    color: "light",
    class: _normalizeClass(_ctx.currentTheme)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_menu, {
        swipeEnabled: _ctx.$route.meta?.noSwipeMenu == undefined,
        "content-id": "main-content",
        side: "end",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Menu", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, {
            color: "primary",
            class: "ion-padding menu-content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, {
                lines: "none",
                color: "none",
                class: "menu-list"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuStore.menuItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "menuItem",
                      key: item.Url
                    }, [
                      (!item.SubItems && _ctx.showMenuItem(item))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_ion_item, {
                              onClick: ($event: any) => (_ctx.handleMenuNavigation(item)),
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                (item.MenuIcon)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass('menu-icon mdi mdi-24px ' + item.MenuIcon)
                                    }, null, 2))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "menu-icon custom-menu-icon",
                                      style: _normalizeStyle(item.Icon ? { 'background-image': _ctx.getImageUrl(item.Icon) } : {})
                                    }, null, 4)),
                                (item.FromVirtWass)
                                  ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$tm("nav." + item.Tekst)), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.Tekst), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : (_ctx.showMenuItem(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createVNode(_component_ion_accordion_group, {
                                lines: "none",
                                value: item.Tekst
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, {
                                    value: item.Tekst,
                                    "toggle-icon": _ctx.chevronUpOutline
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        lines: "none",
                                        slot: "header",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          (item.MenuIcon)
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: _normalizeClass('menu-icon mdi mdi-24px ' + item.MenuIcon)
                                              }, null, 2))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "menu-icon custom-menu-icon",
                                                style: _normalizeStyle(item.Icon ? { 'background-image': _ctx.getImageUrl(item.Icon) } : {})
                                              }, null, 4)),
                                          (item.FromVirtWass)
                                            ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$tm("nav." + item.Tekst)), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.Tekst), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.SubItems, (subItem) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: subItem.Url,
                                          slot: "content",
                                          class: "subMenuItem"
                                        }, [
                                          (!subItem.SubItems && _ctx.showMenuItem(subItem))
                                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                                key: 0,
                                                lines: "none",
                                                onClick: ($event: any) => (_ctx.handleMenuNavigation(subItem)),
                                                color: "primary",
                                                style: {"padding-left":".5rem","background-color":"var(--ion-color-primary)"}
                                              }, {
                                                default: _withCtx(() => [
                                                  (subItem.MenuIcon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass('menu-icon mdi mdi-24px ' + subItem.MenuIcon)
                                                      }, null, 2))
                                                    : (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: "menu-icon custom-menu-icon",
                                                        style: _normalizeStyle(subItem.Icon ? { 'background-image': _ctx.getImageUrl(subItem.Icon) } : {})
                                                      }, null, 4)),
                                                  (subItem.FromVirtWass)
                                                    ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$tm("nav." + subItem.Tekst)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(subItem.Tekst), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : (_ctx.showMenuItem(subItem))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                  _createVNode(_component_ion_accordion_group, {
                                                    lines: "none",
                                                    style: {"padding-left":".5rem","background-color":"var(--ion-color-primary)"},
                                                    value: subItem.Tekst
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_accordion, {
                                                        value: subItem.Tekst,
                                                        "toggle-icon": _ctx.chevronUpOutline
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "none",
                                                            slot: "header",
                                                            color: "primary"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (subItem.MenuIcon)
                                                                ? (_openBlock(), _createElementBlock("i", {
                                                                    key: 0,
                                                                    class: _normalizeClass('menu-icon mdi mdi-24px ' + subItem.MenuIcon)
                                                                  }, null, 2))
                                                                : (_openBlock(), _createElementBlock("div", {
                                                                    key: 1,
                                                                    class: "menu-icon custom-menu-icon",
                                                                    style: _normalizeStyle(subItem.Icon ? { 'background-image': _ctx.getImageUrl(subItem.Icon) } : {})
                                                                  }, null, 4)),
                                                              (subItem.FromVirtWass)
                                                                ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.$tm("nav." + subItem.Tekst)), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(subItem.Tekst), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.SubItems, (nestedItem) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: nestedItem.Url,
                                                              slot: "content",
                                                              class: "subMenuItem"
                                                            }, [
                                                              (!nestedItem.SubItems && _ctx.showMenuItem(nestedItem))
                                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                                    key: 0,
                                                                    lines: "none",
                                                                    color: "primary",
                                                                    style: {"padding-left":".5rem","background-color":"var(--ion-color-primary)"},
                                                                    onClick: ($event: any) => (_ctx.handleMenuNavigation(nestedItem))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (nestedItem.MenuIcon)
                                                                        ? (_openBlock(), _createElementBlock("i", {
                                                                            key: 0,
                                                                            class: _normalizeClass('menu-icon mdi mdi-24px ' + nestedItem.MenuIcon)
                                                                          }, null, 2))
                                                                        : (_openBlock(), _createElementBlock("div", {
                                                                            key: 1,
                                                                            class: "menu-icon custom-menu-icon",
                                                                            style: _normalizeStyle(nestedItem.Icon ? { 'background-image': _ctx.getImageUrl(nestedItem.Icon) } : {})
                                                                          }, null, 4)),
                                                                      (nestedItem.FromVirtWass)
                                                                        ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(_ctx.$tm("nav." + nestedItem.Tekst)), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                        : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(nestedItem.Tekst), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["onClick"]))
                                                                : (_ctx.showMenuItem(nestedItem))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                      _createVNode(_component_ion_accordion_group, {
                                                                        lines: "none",
                                                                        style: {"padding-left":".5rem","background-color":"var(--ion-color-primary)"},
                                                                        value: nestedItem.Tekst
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_ion_accordion, {
                                                                            value: nestedItem.Tekst,
                                                                            "toggle-icon": _ctx.chevronUpOutline
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_ion_item, {
                                                                                lines: "none",
                                                                                slot: "header",
                                                                                color: "primary"
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  (nestedItem.MenuIcon)
                                                                                    ? (_openBlock(), _createElementBlock("i", {
                                                                                        key: 0,
                                                                                        class: _normalizeClass('menu-icon mdi mdi-24px ' + nestedItem.MenuIcon)
                                                                                      }, null, 2))
                                                                                    : (_openBlock(), _createElementBlock("div", {
                                                                                        key: 1,
                                                                                        class: "menu-icon custom-menu-icon",
                                                                                        style: _normalizeStyle(nestedItem.Icon ? { 'background-image': _ctx.getImageUrl(nestedItem.Icon) } : {})
                                                                                      }, null, 4)),
                                                                                  (nestedItem.FromVirtWass)
                                                                                    ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode(_toDisplayString(_ctx.$tm("nav." + nestedItem.Tekst)), 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024))
                                                                                    : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode(_toDisplayString(nestedItem.Tekst), 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024))
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024),
                                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nestedItem.SubItems, (menuItem) => {
                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                  key: menuItem.Url,
                                                                                  slot: "content",
                                                                                  class: "subMenuItem"
                                                                                }, [
                                                                                  (!menuItem.SubItems && _ctx.showMenuItem(menuItem))
                                                                                    ? (_openBlock(), _createBlock(_component_ion_item, {
                                                                                        key: 0,
                                                                                        lines: "none",
                                                                                        color: "primary",
                                                                                        style: {"padding-left":".5rem","background-color":"var(--ion-color-primary)"},
                                                                                        onClick: ($event: any) => (_ctx.handleMenuNavigation(menuItem))
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          (menuItem.MenuIcon)
                                                                                            ? (_openBlock(), _createElementBlock("i", {
                                                                                                key: 0,
                                                                                                class: _normalizeClass('menu-icon mdi mdi-24px ' + menuItem.MenuIcon)
                                                                                              }, null, 2))
                                                                                            : (_openBlock(), _createElementBlock("div", {
                                                                                                key: 1,
                                                                                                class: "menu-icon custom-menu-icon",
                                                                                                style: _normalizeStyle(menuItem.Icon ? { 'background-image': _ctx.getImageUrl(menuItem.Icon) } : {})
                                                                                              }, null, 4)),
                                                                                          (menuItem.FromVirtWass)
                                                                                            ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                                                                                default: _withCtx(() => [
                                                                                                  _createTextVNode(_toDisplayString(_ctx.$tm("nav." + menuItem.Tekst)), 1)
                                                                                                ]),
                                                                                                _: 2
                                                                                              }, 1024))
                                                                                            : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                                                                                default: _withCtx(() => [
                                                                                                  _createTextVNode(_toDisplayString(menuItem.Tekst), 1)
                                                                                                ]),
                                                                                                _: 2
                                                                                              }, 1024))
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1032, ["onClick"]))
                                                                                    : (_ctx.showMenuItem(menuItem))
                                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                                                          _createElementVNode("div", { item: menuItem }, null, 8, _hoisted_6)
                                                                                        ]))
                                                                                      : _createCommentVNode("", true)
                                                                                ]))
                                                                              }), 128))
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["value", "toggle-icon"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["value"])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                            ]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["value", "toggle-icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"])
                                                ]))
                                              : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "toggle-icon"])
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.menuStore.menuItems.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_ion_item, {
                          "router-link": "/logout",
                          "router-direction": "root",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode("Logout", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              color: "secondary"
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "menu-spacer" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ion_item, {
                      class: "version",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Version:", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.webportalStore.version), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "version",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("API Version:", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.webportalStore.vlApiVersion), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["swipeEnabled"]),
      (_openBlock(), _createBlock(_component_ion_router_outlet, {
        id: "main-content",
        key: _ctx.$route.path
      })),
      (_ctx.feedbackStore.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", {
              alt: "loading spinner",
              src: _ctx.loadingSpinner
            }, null, 8, _hoisted_10),
            (_ctx.showSpinner)
              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                  key: 0,
                  name: "crescent"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_my_notifications)
    ]),
    _: 1
  }, 8, ["class"]))
}